module.exports = __webpack_public_path__ + "static/media/Gronlandsbanken_2026_PDF.a0ca5a1a.pdf";